module.exports = __webpack_public_path__ + "img/ptp3.7b118205.jpg";